<template>
  <component
    :is="tag"
    class="ak-masthead__branding"
    :to="to"
    @click.prevent="closeMenu"
  >
    <img :src="logo" class="ak-masthead__branding-img" />
  </component>
</template>

<script>
import { defineComponent, inject } from 'vue'

export default defineComponent({
  /**
   * @type {String}
   * @description This is the name of the component this will also
   * be the tag name of the component to use in templates
   * @example
   * <ak-masthead-brand></ak-masthead-brand>
   */
  name: 'AkMastheadBrand',

  /**
   * @type {Object}
   * @description A collection of properties that may be passed into
   * the component these will be bound to the component instance and
   * may be access in the template and component methods.
   */
  props: {
    /**
     * @type {String|Object}
     * @description The "to" prop when using "router-link" as the tag
     */
    to: {
      default: undefined,
      type: [String, Object],
    },

    /**
     * @type {String}
     * @description The path to the logo file to output
     */
    logo: {
      default: undefined,
      type: String,
    },

    /**
     * @type {String}
     * @description The element type to output
     */
    tag: {
      type: String,
      default: 'a',
    },
  },

  /**
   * @description Sets up the component and returns an object containing all of the
   * attributes for the component to use.
   */
  setup() {
    const parent = inject('akMasthead')

    /**
     * @description Closes the main navigations mobile navbar if it is open
     */
    const closeMenu = () => {
      try {
        parent.closeMenu()
      } catch (ex) {
        /* istanbul ignore next */
      }
    }

    return {
      closeMenu,
    }
  },
})
</script>

<style lang="scss">
@import '../../scss/_settings.scss';
.ak-masthead__branding {
  flex-shrink: 1;
  display: flex;
  align-items: center;
  padding: $spacing-tiny $spacing-small;
  @media screen and #{$mq-nav} {
    padding-left: $spacing-tiny;
  }
  &-img {
    width: 60px;
    flex-grow: 1;
    flex-basis: 0;
    min-width: 35px;
    @media screen and #{$mq-palm} {
      min-width: 45px;
    }
  }
}
</style>
